<footer class="page-footer">
    <p class="mb-0">Copyright © {{currentYear}}. All right reserved.</p>
</footer>
